import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { links } from "../data/dummy";
import { useStateContext } from "../contexts/ContextProvider";
import logo from "../data/logo.png";
import { Col } from "react-bootstrap";

const Sidebar = () => {
  const { activeMenu, setActiveMenu, screenSize, currentColor, userPermID } =
    useStateContext();
  const [newLinks, setNewLinks] = useState([]);
  const allLinks = links;

  const handleCloseSidebar = () => {
    if (activeMenu && screenSize <= 900) setActiveMenu(false);
  };

  const includesAny = (arr, values) => values.some((v) => arr.includes(v));

  useEffect(() => {
    if (allLinks.length > 0 && userPermID.length > 0) {
      var ii = -1;
      var linkss = [];
      if (userPermID.includes(10)) {
        linkss = [];
        linkss.push(allLinks[0]);
        ii++;
      }
      if (
        includesAny(
          userPermID,
          [44, 45, 46, 47, 48, 49, 20, 21, 22, 23, 24, 33, 34],
        )
      ) {
        linkss.push(allLinks[1]);
        ii++;
        if (!includesAny(userPermID, [44, 45, 46])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Stores",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [47, 48, 49])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Inventory",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [20, 21, 22])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Part",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [23, 24])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Serialized",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [33, 34])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Kit",
          );
          linkss[ii].links.splice(index, 1);
        }
      }
      if (includesAny(userPermID, [50, 51, 52, 28, 29, 30, 25, 26, 27])) {
        linkss.push(allLinks[2]);
        ii++;
        if (!includesAny(userPermID, [50, 51, 52])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Quotes",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [28, 29, 30])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Sales",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [25, 26, 27])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Purchase",
          );
          linkss[ii].links.splice(index, 1);
        }
      }
      if (
        includesAny(
          userPermID,
          [17, 18, 19, 11, 12, 13, 14, 15, 16, 56, 57, 58],
        )
      ) {
        linkss.push(allLinks[3]);
        ii++;
        if (!includesAny(userPermID, [17, 18, 19])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Account",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [11, 12, 13])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Customer",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [14, 15, 16])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Supplier",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [56, 57, 58])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Employee",
          );
          linkss[ii].links.splice(index, 1);
        }
      }
      if (includesAny(userPermID, [37, 38, 39])) {
        linkss.push(allLinks[4]);
        ii++;
        if (!includesAny(userPermID, [37, 38, 39])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Receipt",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [37, 38, 39])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Payment",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [37, 38, 39])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Journal",
          );
          linkss[ii].links.splice(index, 1);
        }
        if (!includesAny(userPermID, [37, 38, 39])) {
          const index = linkss[ii].links.findIndex(
            (item) => item.url === "Expense",
          );
          linkss[ii].links.splice(index, 1);
        }
      }
      if (includesAny(userPermID, [40, 41, 42])) {
        linkss.push(allLinks[5]);
      }

      setNewLinks(linkss);
    }
  }, [userPermID, allLinks]);

  const activeLink =
    "flex item-center gap-4 pl-4 pt-2 pb-1 rounded-lg text-white text-md m-1";
  const normalLink =
    "flex item-center gap-4 pl-4 pt-2 pb-1 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-1";

  return (
    <div className="ml-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
      {activeMenu && (
        <>
          <div className="flex justify-between items-center">
            <Link
              to="/Overview"
              onClick={handleCloseSidebar}
              style={{ textDecoration: "none" }}
              className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-tight dark:text-white text-slate-900"
            >
              <Col sm={true} className="p-0">
                <img src={logo} alt="logo" style={{ objectFit: "contain" }} />
              </Col>
            </Link>
            <TooltipComponent content="Close" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu((prev) => !prev)}
                style={{ color: currentColor }}
                className="relative text-xl rounded-full p-2 m-1 hover:bg-light-gray"
              >
                <span className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2" />
                <MdOutlineCancel className="font-bold text-2xl" />
              </button>
            </TooltipComponent>
          </div>
          <div className="m-8 ml-6">
            {newLinks.map((item) => (
              <div key={item.title}>
                <p className="text-gray-400 m-2 mt-4 uppercase cursor-default">
                  {item.title}
                </p>
                {item.links.map((link) => (
                  <NavLink
                    to={`/${link.url}`}
                    key={link.name}
                    onClick={handleCloseSidebar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                      textDecoration: "none",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    {link.icon}
                    <span
                      className="cursor-pointer"
                      style={{ height: "20px", lineHeight: "100%" }}
                    >
                      {link.name}
                    </span>
                  </NavLink>
                ))}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
